

import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";
import LogoTopLeft from "../images/LogoTopLeft.png";
import FacebookIcon from "../images/facebook_icon.png";
import InstagramIcon from "../images/instagram_icon.png";
import TwitterIcon from "../images/twitter_idcon.png";
import ShoppingCartIcon from "../images/ShoppingCartIcon.png";

const KondoFooter = () => {
    return(
        <>
        <div className='footer'>
            <div className='footer-address'>
                <address>
                    <a href='https://kondo.shop-pro.jp/'>
                        <div>
                            <img src={ShoppingCartIcon} alt="オンラインショップ" / >
                            <h4>オンラインショップ</h4>
                        </div>
                    </a>
                    <h3>
                        〒070-0031<br/>
                        北海道旭川市１条通３丁目右1号<br/>
                        TEL:0166-22-2255<br/>
                        FAX:0166-24-5406
                    </h3>
                    <ul>
                        <li>
                            <a href='https://www.facebook.com/kondosome'>
                                <img src={FacebookIcon} alt='facebookアイコン' className='header-icon' />
                            </a>   
                        </li>
                        <li>
                            <a href='https://www.instagram.com/konsome2255/'>
                                <img src={InstagramIcon} alt='instagramアイコン' className='header-icon' />
                            </a>   
                        </li>
                        <li>
                            <a href='https://twitter.com/konsome38195981'>
                                <img src={TwitterIcon} alt='twitterアイコン' className='header-icon' />
                            </a>   
                        </li>
                    </ul>
                </address>
            </div>
            <ul className='footer-menu'>
                <Link to='/article'>
                    <li><span>染の心</span></li>
                </Link>
                <li>
                    <Link to="/product">
                        <span>商品紹介</span>
                    </Link> 
                    <ol className = "list">
                        <a href='http://www.kondo-some.co.jp/lineup/tairyou.html'> 
                        <li><span>- 大漁旗</span></li>
                        </a>
                        <a href='http://www.kondo-some.co.jp/lineup/noren.html'>
                            <li><span>- のれん</span></li>
                        </a>
                        <a href='http://www.kondo-some.co.jp/lineup/hanten.html'>
                            <li><span>- はんてん</span></li>
                        </a>
                        <a href='http://www.kondo-some.co.jp/lineup/kaiki.html'>
                            <li><span>- 会旗</span></li>
                        </a>
                        <a href='http://www.kondo-some.co.jp/lineup/nobori.html'>
                            <li><span>- のぼり</span></li>
                        </a>
                        <a href='http://www.kondo-some.co.jp/lineup/jinjya.html'>
                            <li><span>- 神社</span></li>
                        </a>
                        <a href='http://kondo.shop-pro.jp/'>
                            <li><span>- 染製品</span></li>
                        </a>
                        <a href='http://www.kondo-some.co.jp/gift/'>
                            <li><span>- ご贈答品</span></li>
                        </a>
                    </ol>
                </li>
                <li>
                    <Link to='/company'>
                        <span>会社案内</span>
                    </Link>
                    <ol className = "list">
                        <Link to='/company'>
                            <li><span>- 会社概要</span></li>
                        </Link>
                        <Link to='/story'>
                            <li><span>- いまむかし</span></li>
                        </Link>
                    </ol>
                </li>
                <Link to='/news'>
                    <li><span>お知らせ</span></li>
                </Link>
                <li>
                    <Link to="/contact">
                        <span>お問い合せ</span>
                    </Link>
                    <ol className = "list">
                        <Link to="/privacypolicy">
                            <li><span>- 個人情報の取り扱い</span></li>
                        </Link> 
                    </ol>
                </li>
                <a href='https://kondo.shop-pro.jp/'>
                    <li className = "list-online">
                        <img src={ShoppingCartIcon} alt="オンラインショップ" / >
                        <span>オンラインショップ</span>
                    </li>
                </a>
            </ul>
        </div>
        <div className='copyright'>
            <p className='copyright'>Copyright &copy; KONDO Co.,Ltd. All Rights Reserved.</p>
        </div>
        </>
    )
}
export default KondoFooter;